import o from "./CommonDialog.vue2.js";
/* empty css                  */
import m from "../../_virtual/_plugin-vue_export-helper.js";
const p = /* @__PURE__ */ m(o, [["__scopeId", "data-v-9613ad7c"]]);
export {
  p as default
};
